module Omni.Booker {
    NgModule.component("omniBookerFindHeader", {
        bindings: {
            propertyDetail: "="
        },
        templateUrl: "omni-booker-find-header.html",
        controller: class OmniBookerHeaderController {
            searchInput: string; // Search input (for autocomplete)
            searchResults: any[];    // Search results (for autocomplete)
            selectedProperty: BookingDataResult; // Selected result (autocomplete)
            selectedCategory: string;    // Selected category (autocomplete)
            propertyData;    // Property data (for autocomplete)
            showResults: boolean;
            showSelectionMessage: boolean;
            showWhereGoingLabel: boolean;
            opaqueBackground: boolean;

            // Bindings
            private propertyDetail: PropertyDetail;   // This is set from the bindings attribute of this component, it's set externally

            private findDataPromise: ng.IPromise<any>;  // AJAX promise for booking search data (autocomplete)

            static $inject = [
                "omni.bookingapiservice",
                "omPropertyFilterFilter",
                "bookerConfig",
                "$scope",
                "$rootScope",
                "$timeout"
            ];
            constructor(
                private readonly omniBookingService: IBookingApiService,
                private readonly omPropertyFilter,
                private readonly bookerConfig: Constants.IBookerConfiguration,
                private readonly $scope,
                private readonly $rootScope,
                private readonly $timeout: ng.ITimeoutService
            ) {
                this.opaqueBackground = this.bookerConfig.IsBookerOpaque;
                this.$scope.$on("bookerStateUpdate", () => { this.onBookerStateUpdate(); });
            }

            public $onInit() {
                this.searchInput = "";
                this.updateWhereGoingDisplay();

                // Get the booking data
                this.getLocalBookingData();
            }

            public clearFind() {
                if (this.selectedProperty) {
                    this.selectedProperty.selected = false;
                    this.selectedProperty = undefined;
                }

                this.selectedCategory = undefined;
                this.searchInput = "";

                this.propertyDetail.HotelId = "";
                this.propertyDetail.PropertyName = "";

                this.showResults = false;
                this.searchResults = [];
                this.focusSearchInput();
                this.updateWhereGoingDisplay();
            }

            public clearSelected() {
                if (this.selectedProperty) {
                    this.selectedProperty.selected = false;
                    this.selectedProperty = undefined;
                }

                this.selectedCategory = undefined;

                this.propertyDetail.HotelId = "";
                this.propertyDetail.PropertyName = "";
                this.propertyDetail.IsComingSoon = false;
                this.propertyDetail.ComingSoonText = "";
                this.propertyDetail.HotelLink = "";
                this.propertyDetail.RedeemFreeNights = false;
                this.propertyDetail.IsVillas = false;

                this.updateWhereGoingDisplay();
            }

            private focusResult(item: BookingDataResult, itemIndex: number) {
                var nthChildVal = itemIndex + 1;
                var targetResult: any = document.querySelectorAll(".result-category-list[data-category-name='" + item.category + "'] li:nth-child("+ nthChildVal +") a")[0];

                targetResult.focus();
            }

            private resultFocused(item: BookingDataResult) {
                //console.log("focusedItem", item);
                if (this.selectedProperty) {
                    this.selectedProperty.selected = false;
                }

                this.selectedCategory = item.category;
                this.selectedProperty = item;
                this.selectedProperty.selected = true;
            }

            public selectResult(item: BookingDataResult) {
                if (item.IsGha) {
                    this.clearFind();
                    return;
                }

                if (this.selectedProperty) {
                    this.selectedProperty.selected = false;
                }

                this.selectedCategory = item.category;
                this.selectedProperty = item;
                this.selectedProperty.selected = true;

                this.propertyDetail.HotelId = this.selectedProperty.ItemIdGuid;
                this.propertyDetail.PropertyName = this.selectedProperty.ResultLabel;
                this.propertyDetail.IsComingSoon = this.selectedProperty.IsComingSoonProperty;
                this.propertyDetail.ComingSoonText = this.selectedProperty.ComingSoonText;
                this.propertyDetail.HotelLink = this.selectedProperty.HotelLink;
                this.propertyDetail.RedeemFreeNights = this.selectedProperty.RedeemFreeNights;
                this.propertyDetail.IsVillas = this.selectedProperty.IsVillas;
                this.searchInput = this.propertyDetail.PropertyName;
                this.showResults = false;
                this.searchResults = [];
            }

            public focusNextResult() {
                if (!this.getSelectedCategory()) {
                    this.selectedCategory = this.getFirstCategory().name;
                }

                var category = this.getSelectedCategory();

                var idx = category.results.indexOf(this.selectedProperty);
                if (category.results.length - 1 > idx) {
                    this.focusResult(category.results[idx + 1], idx + 1);
                } else {
                    // Last in category, choose next category
                    this.focusNextCategory();
                }
            }

            public focusPreviousResult() {
                if (!this.getSelectedCategory()) {
                    this.selectedCategory = this.getFirstCategory();
                }

                var category = this.getSelectedCategory();

                var idx = category.results.indexOf(this.selectedProperty);
                if (idx > 0) {
                    this.focusResult(category.results[idx - 1], idx - 1);
                } else {
                    // first in category, choose previous category
                    this.focusPreviousCategory();
                }
            }

            public focusNextCategory() {
                if (!this.getSelectedCategory()) {
                    // if no category is selected, choose the first
                    this.selectedCategory = this.getFirstCategory().name;
                } else {
                    var nextCategory = undefined;
                    for (var i = 0, ct = this.searchResults.length; i < ct; i++) {
                        if (this.searchResults[i].name === this.selectedCategory) {
                            if (i == ct - 1) {
                                // This is the last category, we cannot go further
                                return;
                            } else {
                                nextCategory = this.searchResults[i + 1];
                            }
                        }
                    }
                    this.selectedCategory = nextCategory.name;
                }

                // always select a new property
                this.focusResult(this.getSelectedCategory().results[0], 0);
            }

            public focusPreviousCategory() {
                if (!this.getSelectedCategory()) {
                    // if no category is selected, choose the first
                    this.selectedCategory = this.getFirstCategory().name;
                } else {
                    var previousCategory = undefined;
                    for (var i = 0, ct = this.searchResults.length; i < ct; i++) {
                        if (this.searchResults[i].name === this.selectedCategory) {
                            if (i == 0) {
                                // This is the first category, we cannot go further
                                return;
                            } else {
                                previousCategory = this.searchResults[i - 1];
                            }
                        }
                    }
                    this.selectedCategory = previousCategory.name;
                }

                // always select a new property
                var numResults = this.getSelectedCategory().results.length;
                this.focusResult(this.getSelectedCategory().results[numResults - 1], numResults - 1);
            }

            public keyupInSearch($event: KeyboardEvent) {
                if ($event.key.indexOf("Up") >= 0) {
                    this.focusSearchResults();
                    $event.preventDefault();
                } else if ($event.key.indexOf("Down") >= 0) {
                    this.focusSearchResults();
                    $event.preventDefault();
                } else if ($event.key.indexOf("Escape") >= 0) {
                    this.clearFind();
                }
            }

            public keyupInResults($event: KeyboardEvent) {
                if ($event.key.indexOf("Up") >= 0) {
                    this.focusPreviousResult();
                    $event.preventDefault();
                } else if ($event.key.indexOf("Down") >= 0) {
                    this.focusNextResult();
                    $event.preventDefault();
                } else if ($event.key.indexOf("Enter") >= 0) {
                    var selected = this.getSelectedResult();
                    if (selected == undefined) {
                        this.showSelectionMessage = true;
                    } else {
                        this.showSelectionMessage = false;
                        this.selectResult(selected);
                    }
                } else if ($event.key.indexOf("Escape") >= 0) {
                    this.clearFind();
                }
            }

            public keydown($event: KeyboardEvent) {
                if ($event.key.indexOf("Up") >= 0 || $event.key.indexOf("Down") >= 0) {
                    $event.preventDefault();
                    $event.view.event.preventDefault();
                }
            }

            public filterAutocompleteData() {
                // We must always re-evaluate whether or not we display the where going label.
                this.updateWhereGoingDisplay();
                if (this.selectedProperty) {
                    // If the user has already made a selection and is changing their input, we need to reset the selection
                    this.selectedProperty.selected = false;
                    this.selectedProperty = undefined;
                }

                if (this.searchInput.length < 3) {
                    this.searchResults = [];
                    this.showResults = false;

                    return;
                }

                this.getLocalBookingData().then(() => {
                    this.showResults = true;
                    // cleanup previous selected properties and wipe out selections 
                    if (this.selectedProperty) {
                        this.selectedProperty.selected = false;
                    }

                    this.selectedCategory = undefined;
                    this.selectedProperty = undefined;

                    this.searchResults = this.omPropertyFilter(this.propertyData, this.searchInput);

                    // Gather all categories from search results and build into a new object
                    var categoriesUnique = this.searchResults.reduce((categories, currentItem) => {
                        var foundCategory = undefined;
                        for (var i = 0, ct = categories.length; i < ct; i++) {
                            if (categories[i].name === currentItem.category) {
                                foundCategory = categories[i];
                            }
                        }

                        // Add to categories with special handling for City items.
                        if (foundCategory) {
                            if (currentItem.category === "City") {
                                if (currentItem.label.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0) {
                                    if (currentItem.ResultLabel.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0) {
                                        foundCategory.results.push(currentItem);
                                    }
                                }
                            } else {
                                foundCategory.results.push(currentItem);
                            }

                        } else {
                            if (currentItem.category === "City") {
                                if (currentItem.label.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0) {
                                    if (currentItem.ResultLabel.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0) {
                                        categories.push({ name: currentItem.category, results: [currentItem] });
                                    }
                                }
                            } else {
                                categories.push({ name: currentItem.category, results: [currentItem] });
                            }

                        }

                        return categories;
                    }, []);
                    
                    // Reorder results to put Omni ahead of GHA in each category
                    categoriesUnique.forEach((category) => {
                        category.results.sort((a, b) => {
                            if (a.IsGha && !b.IsGha) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });
                    });

                    this.searchResults = categoriesUnique;
                });
            }

            public getLocalBookingData = () => {
                // If we're fetching the data don't try to fetch it again
                if (this.findDataPromise) {
                    return this.findDataPromise;
                }

                this.findDataPromise = this.omniBookingService.GetFindData(this.bookerConfig.IncludeGha);
                this.findDataPromise.then((data) => {
                    this.propertyData = data;
                });

                return this.findDataPromise;
            }

            private getSelectedResult(): BookingDataResult {
                var result: BookingDataResult = undefined;
                if (this.getSelectedCategory()) {
                    var category = this.getSelectedCategory();
                    for (var i = 0, ct = category.results.length; i < ct; i++) {
                        if (category.results[i].selected) {
                            result = category.results[i];
                        }
                    }
                }

                return result;
            }

            private getSelectedCategory() {
                var selectedCategory = undefined;

                for (var i = 0, ct = this.searchResults.length; i < ct; i++) {
                    if (this.searchResults[i].name === this.selectedCategory) {
                        selectedCategory = this.searchResults[i];
                    }
                }

                return selectedCategory;
            }

            private getFirstCategory() {
                var firstCategory = undefined;

                if (this.searchResults && this.searchResults.length > 0) {
                    firstCategory = this.searchResults[0];
                }

                return firstCategory;
            }

            private updateWhereGoingDisplay() {
                // Evaluates the search input and shows or hides "where are you going" label accordingly
                if (this.searchInput.length === 0) {
                    this.showWhereGoingLabel = true;
                } else {
                    this.showWhereGoingLabel = false;
                }

            }

            private onBookerStateUpdate() {
                this.focusSearchInput();
            }

            private focusSearchInput() {
                this.$timeout(
                    () => {
                        angular.element("#where-going").focus();
                    }, 500);
            }

            private focusSearchResults() {
                this.$timeout(
                    () => {
                        var firstResult: any = document.querySelectorAll(".result-category-list:first-of-type li:first-of-type a")[0];
                        firstResult.focus();
                    }, 75);
            }
        }
    });
}
